export default {
  title: 'Cerrar disponibilidad',
  close_availabilities_form: {
    date_range: {
      label: 'Seleccionar una fecha y hora.',
    },
  },
  reason: {
    label: 'Añadir un motivo (opcional)',
    placeholder: 'Introducir descripción...',
  },
  recurring: {
    label: 'Recurrente anualmente',
  },
  buttons: {
    save: 'Guardar',
    cancel: 'Cancelar',
    add: '+ Añadir excepción',
    reactivate: 'Reactivar',
  },
  reservations: {
    title: 'Reservas',
    description: '¿Deseas añadir la excepción de horario a las reservas?',
    add: 'Añadir',
    cancel: 'Cancelar',
  },
  projects: {
    online_shop: 'Tienda online',
    reservations: 'Reservas',
    storefront: 'Storefront',
  },
  success_messages: {
    reservation_updated: 'Excepción de horario añadida correctamente',
  },
  error_messages: {
    date_range_required: 'Selecciona un rango de fechas.',
    creation_failed: 'Error al crear la excepción',
    overlapping_schedule_exception: 'Ya tienes una excepción de horario para ese intervalo de tiempo',
    merge_schedule_exceptions:
      'La siguiente excepción de horario {{oldDate}} se fusionará con {{newDate}}. También puedes actualizar el intervalo de fechas de {{oldDate}}.',
  },
};
